import { http } from './http_service';

//Get list of destinations with paginate
export function listPage(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        selectedStatus:obj.selectedStatus,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field
    }
    return http().get(`/designations/list-page/page`, {
        params:params
    });
}
//Get Single
export function single(id){
    return http().get(`/designations/single/${id}`);
}
//Add one
export function add(data){
    return http().post('/designations/add', data)
}
//Update
export function update(id, data){
    return http().post(`/designations/update/${id}`, data)
}
//Get data for dropdown
export function dropdown(){
  return http().get(`/designations/dropdown`);
}

